import { IdentityProvidersTab } from "./IdentityProvidersTab";

export function IdentityProvidersSettings() {
  return <IdentityProvidersTab />;
}